import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/auth';
import { 
    FETCH_USER_PROFILE, 
    SUBSCRIBE_USER_FAVOURITES, 
    UPDATE_USER_FAVOURITES, 
    CLEAR_USER_FAVOURITES 
} from "./types";

export const setUserProfile = (uid, email) => dispatch => {
    console.log('fetchUserProfile is called', email);
    dispatch({
        type: FETCH_USER_PROFILE,
        uid: uid,
        email: email
    });
};

export const updateUserFavourites = (uid, favouriteList) => dispatch => {
    console.log('updateUserFavourites is called', uid, favouriteList);

    const db = firebase.firestore();
    db.collection("profiles").doc(uid).update({
        favourites: favouriteList
    })
    .then(() => {
        console.log("updateUserFavourites: updated");
        dispatch({
            type: UPDATE_USER_FAVOURITES,
            favourites: favouriteList
        });
    })
    .catch(error => {
        console.error("updateUserFavourites : Error updating profiles document: ", error);
    });
};

export const subscribeUserFavourites = (uid) => dispatch => {
    console.log('subscribeUserFavourites is called', uid);

    const db = firebase.firestore();
    return db.collection("profiles").doc(uid)
        .onSnapshot(doc => {
            if (doc.exists) {
                console.log("subscribeUserFavourites : Document profiles data:", doc.data());
                dispatch({
                    type: SUBSCRIBE_USER_FAVOURITES,
                    favourites: doc.data().favourites
                });
            } else {
                console.log("subscribeUserFavourites: No such profiles document!");
            }
        });
};

export const clearUserFavourites = () => dispatch => {
    console.log('clearUserFavourites is called');
    dispatch({
        type: CLEAR_USER_FAVOURITES
    });
};


// WEBPACK FOOTER //
// ./src/actions/userProfileActions.js